import { render, staticRenderFns } from "./GuestDropZone.vue?vue&type=template&id=53587bec&scoped=true&"
import script from "./GuestDropZone.vue?vue&type=script&lang=js&"
export * from "./GuestDropZone.vue?vue&type=script&lang=js&"
import style0 from "./GuestDropZone.vue?vue&type=style&index=0&id=53587bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53587bec",
  null
  
)

export default component.exports